<template>
  <div class="alertBox">
    <div class="alertBox_oldson">
      <div class="AO_oldson">
        <div @click="nice">
          {{
            vipji < 4
              ? "海星点转赠点数将转到对方赠点账户，请确认。"
              : "海星点转赠点数将转到对方赠点账户，使用赠点转赠将扣除本次转赠赠点数额的10%，请确认。"
          }}
        </div>
      </div>
      <div class="AO_twoson" @click="Takeme">我知道了</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['vipji'],
  data () {
    return {
      Dad_alertBox_hidden: false
    }
  },
  methods: {
    Takeme () {
      this.$emit('func', this.Dad_alertBox_hidden)
    },
    nice () {
      console.log(this.alertBoxCard)
    }
  }
}
</script>
<style>
.alertBox {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #00000066;

  /* position: relative;
  margin: 0 auto;
  padding: 1em;
  max-width: 23em;
  background: hsla(0, 0%, 100%, 0.25) border-box;
  overflow: hidden;
  border-radius: 0.3em;
  box-shadow: 0 0 0 1px hsla(0, 0%, 100%, 0.3) inset,
    0 0.5em 1em rgba(0, 0, 0, 0.6);
  text-shadow: 0 1px 1px hsla(0, 0%, 100%, 0.3); */
}
.alertBox::before {
  /* content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: -30px;
  z-index: -1;
  -webkit-filter: blur(20px);
  filter: blur(20px); */
}
.alertBox_oldson {
  color: white;
  width: 15%;
  height: 20%;
  background-color: #25304c;
  overflow: hidden;
  position: relative;
  /* border: 1px solid #bfbfbf99; */
  border-radius: 5px;
}
@media screen and (max-width: 450px) {
  .alertBox_oldson {
    height: 35%;
    width: 60%;
    font-size: 18px;
  }
}
@media screen and (min-width: 750px) {
  .alertBox_oldson {
    height: 20%;
    width: 25%;
  }
  .AO_twoson {
    font-size: 20px;
  }
}
.AO_oldson {
  height: 72.7%;
  width: 100%;
  font-size: 18px;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
}
.AO_oldson div {
  width: 100%;
  text-align: center;
}
.AO_twoson {
  height: 24.3%;
  width: 100%;
  background: linear-gradient(to right, #fff282, #f4c91d);
  position: absolute;
  left: 0;
  bottom: 0;
  color: black;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-weight: 900;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/aletBox.vue